import React from "react";
import PostBlog from "./Blog/PostBlog";

export default function Home() {
  return (
    <>
      <PostBlog />
    </>
  );
}
